import React,{ useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as path from '../../../route/PathConfig';
import HomeMain from '../../presentation/section/home-page/HomeMain';
import { getExpress } from '../../../service/api';
import { noticeOffRequest } from '../../../actions/noticeoff';

const Home = (props) => {

  const [noticeTabContents, setNoticeTabContents] = useState()
  const [homeTopTenData, setHomeTopTenData] = useState()
  const [noticeShow, setNoticeShow] = useState(false);

  useEffect(() => {
    getNoticeData(
      (result)=>{
        setNoticeTabContents(result)
      });

    getTopTenData(
      (result) => {
        setHomeTopTenData(result)
      });
      console.log(props.noticeOn)
      setNoticeShow(props.noticeOn);
  },[])

  const handleNoticeClose = () => {
    setNoticeShow(false);
  }
  const handleNoticeOff = () => {
    setNoticeShow(false);
    props.noticeOffRequest();
  }

  const getNoticeData = (callback) => {
    getExpress('/users/notice',
    (res) => {
      callback(res.data);
    });
  }

  const getTopTenData = (callback) => {
    getExpress('/users/home/top-ten',
    (res) => {
      callback(res.data);
    })
  }

  let history = useHistory();

  const handleViewMoreNotice = () => {
    history.push(`${path.NOTICE}`);
  }

  return (
    <>
      <HomeMain topTenData={homeTopTenData} noticeTabContents={noticeTabContents} handleViewMoreNotice={handleViewMoreNotice}
       noticeShow={noticeShow} handleNoticeClose={handleNoticeClose} handleNoticeOff={handleNoticeOff}/>
    </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole : state.AuthManager.status.currentRole,
  noticeOn: state.AuthManager.status.noticeOn
});

const mapDispatchToProps = (dispatch) => {
  return {
    noticeOffRequest: () => {
      return dispatch(noticeOffRequest());
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps) (Home);